/** Where the coachmark's box starts, so anything stacking beneath it can line up with it. */
export function getCoachmarkTop(topOffset: string | undefined, isOnline: boolean) {
    return `calc(${topOffset ?? "16px"} + ${isOnline ? "0px" : "24px"})`;
}
